import AppModalContainer from '@nxsys/components/AppModalContainer';
import { defaultAccommodationTypesOptions } from '@nxsys/constants/AppConstants';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IBIK } from '@nxsys/types/models/BIK';
import React, { useRef, useState } from 'react';
import AccommodationForm, {
  AccommodationFormRef,
  AccommodationFormValues,
} from './AccommodationForm';

type EditAccommodationProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: AccommodationFormValues) => Promise<void>;
  data: IBIK;
};

const EditAccommodationModal: React.FC<EditAccommodationProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditAccommodationProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<AccommodationFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: AccommodationFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editVehicle']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <AccommodationForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          startDate: data.startDate,
          baseBenefitOnType:
            defaultAccommodationTypesOptions.find(
              (option) => option.value === data.baseBenefitOnType,
            ) || null,
          description: data.description,
          endDate: data.endDate,
          valueOfFurnitureProvided: data.valueOfFurnitureProvided?.toString(),
          eeContribution: data.eeContribution?.toString(),
          totalEeContribution: data.totalEeContribution?.toString(),
        }}
      />
    </AppModalContainer>
  );
};

export default EditAccommodationModal;
